import RegistrationScreen from "@/src/screens/auth/registration-screen/registration-screen";

function registrationPage() {
  return <RegistrationScreen />;
}
export default registrationPage;
